import API from './api'
import snackbarMessages from "./snackbarMessages"
import GLOBALS from "./GLOBALS";
import {handleError} from "./handleError";
import { successMessage } from './alertMessages';
import store from "../redux/store";
import {enqueueSnackbar} from "../redux/actions/snackbarActions";

export const SupportService = {

    sendSupportRequest: function (subject, body) {
      return API.post(GLOBALS.ENDPOINTS.SUPPORT.SEND + '/0', {subject, body})
        .then((response) => {
          store.dispatch(enqueueSnackbar(successMessage(snackbarMessages.success.support.send)))
          return response?.data
      })
          .catch((error) => {
            handleError(error, snackbarMessages.error.support.send);
          })
   }
};

